import React from 'react';
import { Box, Text, Badge, Divider } from '@razorpay/blade/components';
import pluralize from 'pluralize';
import { BankAccountRequest } from 'api/employeeBankAccount';
import { bankAccountVerificationStatus } from 'components/EmployeeDetails/BankAccountDetails/data';

export const BankAccountVerificationSummary = ({
  selectedRequests,
}: {
  selectedRequests: Record<string, BankAccountRequest>;
}) => {
  const { matchCount, noMatchCount, unverifiedCount } = Object.keys(selectedRequests).reduce(
    (acc, id) => {
      if (selectedRequests[id].verification_status === bankAccountVerificationStatus.mismatch) {
        acc.noMatchCount++;
      } else if (
        selectedRequests[id].verification_status === bankAccountVerificationStatus.verified
      ) {
        acc.matchCount++;
      } else {
        acc.unverifiedCount++;
      }
      return acc;
    },
    { matchCount: 0, noMatchCount: 0, unverifiedCount: 0 },
  );

  return (
    <Box
      borderRadius="medium"
      borderColor="surface.border.gray.muted"
      borderWidth="thin"
      backgroundColor="surface.background.gray.moderate"
      padding="spacing.5"
      display="flex"
      flexDirection="column"
      marginBottom="spacing.6"
      gap="spacing.5">
      <Text size="small" weight="semibold" color="surface.text.gray.muted">
        Verification Status
      </Text>
      <Box>
        {!!unverifiedCount && (
          <>
            <Box display="flex" alignItems="center" justifyContent="space-between">
              <Text size="medium" weight="regular" color="surface.text.gray.normal">
                {unverifiedCount} {pluralize('Request', unverifiedCount)}
              </Text>
              <Badge color="notice" size="large" marginLeft="spacing.3" testID="unverified-count">
                Unverified
              </Badge>
            </Box>
            {!!(noMatchCount || matchCount) && (
              <Divider
                dividerStyle="dashed"
                variant="muted"
                thickness="thinner"
                marginY="spacing.3"
              />
            )}
          </>
        )}
        {!!noMatchCount && (
          <>
            <Box display="flex" alignItems="center" justifyContent="space-between">
              <Text size="medium" weight="regular" color="surface.text.gray.normal">
                {noMatchCount} {pluralize('Request', noMatchCount)}
              </Text>
              <Badge color="notice" size="large" marginLeft="spacing.3" testID="no-match-count">
                No Match
              </Badge>
            </Box>
            {!!matchCount && (
              <Divider
                dividerStyle="dashed"
                variant="muted"
                thickness="thinner"
                marginY="spacing.3"
              />
            )}
          </>
        )}

        {!!matchCount && (
          <Box display="flex" alignItems="center" justifyContent="space-between">
            <Text size="medium" weight="regular" color="surface.text.gray.normal">
              {matchCount} {pluralize('Request', matchCount)}
            </Text>
            <Badge color="positive" size="large" marginLeft="spacing.3" testID="match-count">
              Match
            </Badge>
          </Box>
        )}
      </Box>
    </Box>
  );
};
